<template>
  <div class="unauthorized">
    <div class="unauthorized__card">
      <h1 class="hb-page-title">Accès non autorisé</h1>
      <p class="hb-page-sub">
        Vous n'êtes pas autorisé à vous connecter ici. Essayez un autre compte, ou contactez le support technique.
      </p>
      <v-btn color="primary" depressed @click="logout()">
        <v-icon left small>logout</v-icon>
        Se déconnecter
      </v-btn>
    </div>
  </div>
</template>
<script>
  import { logout } from '@/utils/Keycloak'
  export default {
    methods: {
      logout() {
        logout()
      }
    }
  }
</script>

<style lang="scss" scoped>
.unauthorized {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
  background: var(--surface);
}

.unauthorized__card {
  max-width: 440px;
  padding: var(--space-6);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  background: var(--surface-raised);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4);

  .hb-page-sub {
    margin: 0;
  }
}

// Téléphone : marges intérieures de la carte réduites
@media (max-width: 599.98px) {
  .unauthorized__card {
    padding: var(--space-5) var(--space-4);
  }
}
</style>
